// extracted by mini-css-extract-plugin
module.exports = {"content":"layout_content__XzT01","main":"layout_main__88FzF"};